import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { authReducer } from "./auth/AuthSlice";
import { patientReducer } from "./patient/PatientSlice";
import { totalAddressReducer } from "./service/AddressSlice";
import { dateTimeReducer } from "./service/DateTimeSlice";
import { professionSlice } from "./service/ProfessionSlice";
import { serviceSlice } from "./service/ServiceSlice";
import { userReducer } from "./user/userSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  service: serviceSlice.reducer,
  profession: professionSlice.reducer,
  dateTime: dateTimeReducer,
  totalAddress: totalAddressReducer,
  patient: patientReducer,
  user: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);
export  {persistor,store};
